Chaplin = require 'chaplin'

mediator = module.exports = Chaplin.mediator
